<div class="sidenav" [ngClass]="{'collapsed-sidebar': isCollapsed, 'sidebar': !isCollapsed}">
    <mat-drawer-container class="drawer-container">
        <mat-drawer class="drawer side-bar-class" mode="side" opened>
            <div class="drawer__header">
                <div class="drawer__header--icon">
                    <div class="hamburger-menu">
                        <mat-icon class="chevron-button" [ngClass]="{'rotated': isCollapsed}"
                            (click)="toggleSidebar()">chevron_left</mat-icon>
                    </div>
                    <img class="ps4-icon" [src]="appLogoUrl" alt="Primaria Sectorului 4" />
                    <div class="drawer__header--text">
                        <div class="drawer__header--text--title">{{appName}}</div>
                        <div class="drawer__header--text--title--minWidth">{{appNameSmall}}</div>
                        <br>
                        <div class="drawer__header--text--subtitle faded-text">
                            {{appDescription}}
                        </div>
                        <div class="drawer__header--text--subtitle--minWidth faded-text">
                            {{appDescriptionSmall}}
                        </div>
                    </div>
                    <div class="drawer__header--social-container">
                        <div class="drawer__header--social" (click)="redirectToinDeskPlatform()">
                            <i class="fa-solid fa-desktop pointer" style="color: #fff"></i>
                            <span class="drawer__header--social--text faded-text pointer">inDesk</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="drawer__buttons">
                <mat-accordion>
                    <p class="menu-link" routerLink="/documente" [class.menu-active]="'/documente' === activeOption"
                        (click)="setActive('/documente')">
                        <img src="assets/icons/companii.svg" alt="" />
                        <span>Documente</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('indoc-module.borderouri.list')" class="menu-link"
                        routerLink="/borderou" [class.menu-active]="'/borderou' === activeOption"
                        (click)="setActive('/borderou')">
                        <img src="assets/icons/borderou.svg" alt="" />
                        <span>Borderou</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('indoc-module.rapoarte-activitati.list')"
                        class="menu-link" routerLink="/raport-activitate"
                        [class.menu-active]="'/raport-activitate' === activeOption"
                        (click)="setActive('/raport-activitate')">
                        <img src="assets/icons/rapoarte-activitate.svg" alt="" />
                        <span>Rapoarte Activitate</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('indoc-module.rapoarte-activitati.matrix.list')"
                        class="menu-link" routerLink="/raport-activitate-detaliat"
                        [class.menu-active]="'/raport-activitate-detaliat' === activeOption"
                        (click)="setActive('/raport-activitate-detaliat')">
                        <img src="assets/icons/rapoarte-activitate.svg" alt="" />
                        <span>Raport Activitate (Detaliat)</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('indoc-module.rapoarte-amenzi.list')" class="menu-link"
                        routerLink="/raport" [class.menu-active]="'/raport' === activeOption"
                        (click)="setActive('/raport')">
                        <img src="assets/icons/rapoarte-amenzi.svg" alt="" />
                        <span>Rapoarte (Amenzi)</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('indoc-module.inbox.list')" class="menu-link"
                        routerLink="/inbox" [class.menu-active]="'/inbox' === activeOption"
                        (click)="setActive('/inbox')">
                        <img class="sidenav-request-btn" src="assets/icons/cereri.svg" alt="" />
                        <span>Inbox</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('indoc-module.notificari-email.list')" class="menu-link"
                        routerLink="/notificari-email" [class.menu-active]="'/notificari-email' === activeOption"
                        (click)="setActive('/notificari-email')">
                        <img src="assets/icons/notificari.svg" alt="" />
                        <span>Notificări Email</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('indoc-module.registre-documente.list')"
                        class="menu-link" routerLink="/registru" [class.menu-active]="'/registru' === activeOption"
                        (click)="setActive('/registru')">
                        <img src="assets/icons/borderou.svg" alt="" />
                        <span>Registru</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('indoc-module.awbs.list')" class="menu-link"
                        routerLink="/awb" [class.menu-active]="'/awb' === activeOption" (click)="setActive('/awb')">
                        <img src="assets/icons/awb.svg" alt="" />
                        <span>AWB</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('indoc-module.sabloane-inbox-indoc.list')"
                        class="menu-link" routerLink="/sabloane" [class.menu-active]="'/sabloane' === activeOption"
                        (click)="setActive('/sabloane')">
                        <img src="assets/icons/sabloane.svg" alt="" />
                        <span>Șabloane (Inbox)</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('indoc-module.beneficiari.list')" class="menu-link"
                        routerLink="/entitati" [class.menu-active]="'/entitati' === activeOption"
                        (click)="setActive('/entitati')">
                        <img src="assets/icons/entitati.svg" alt="" />
                        <span>Beneficiari</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('indoc-module.evidenta-persoane.list')" class="menu-link"
                        routerLink="/verificare-evidenta" [class.menu-active]="'/verificare-evidenta' === activeOption"
                        (click)="setActive('/verificare-evidenta')">
                        <img src="assets/icons/verificare-evidenta.svg" alt="" />
                        <span>Verificare Evidență</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('indoc-module.persoane-decedate.list')" class="menu-link"
                        routerLink="/decedati" [class.menu-active]="'/decedati' === activeOption"
                        (click)="setActive('/decedati')">
                        <img src="assets/icons/persoane-decedate.svg" alt="" />
                        <span>Persoane Decedate</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('indoc-module.operator-signing-logs.list')"
                        class="menu-link" routerLink="/operator-signing-logs"
                        [class.menu-active]="'/operator-signing-logs' === activeOption"
                        (click)="setActive('/operator-signing-logs')">
                        <img src="assets/icons/registru.svg" alt="" />
                        <span>Loguri Semnare</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('indoc-module.audit-logs.list')" class="menu-link"
                        routerLink="/audit-logs" [class.menu-active]="'/audit-logs' === activeOption"
                        (click)="setActive('/audit-logs')">
                        <img src="assets/icons/registru.svg" alt="" />
                        <span>Jurnal Audit</span>
                    </p>
                    <p *ngIf="hasAnySettingsPermission()" class="menu-link" routerLink="/settings"
                        [class.menu-active]="'/settings' === activeOption" (click)="setActive('/settings')">
                        <img src="assets/icons/setari.svg" alt="" />
                        <span>Setări</span>
                    </p>

                    <mat-expansion-panel *ngIf="hasAnyAdministrativeSettingsPermission()" class="sidenav-accordion"
                        (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                        <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState">
                            <mat-panel-title class="sidenav-accordion">
                                <div class="panel-title">
                                    <img src="../../../../assets/icons/administrative.svg" alt="" />
                                    <span>Administrativ</span>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p class="settings-option-menu" routerLink="/admin-settings"
                            [class.menu-active]="'/admin-settings' === activeOption"
                            (click)="setActive('/admin-settings')">
                            <img src="../../../../assets/icons/setari.svg" alt="" />
                            <span>Setări</span>
                        </p>
                    </mat-expansion-panel>
                </mat-accordion>

                <div class="footer">
                    <div class="col-sm-12 px-2" [class.hidden]="isCollapsed == true">
                        <small [innerHTML]="env.config.copyrightText"></small>
                    </div>
                    <div class="logout-button" (click)="logout()">
                        <img src="assets/icons/logout.svg" alt="Deconectare" />
                        <div click="logout()" class="logout-button--text">Deconectare</div>
                    </div>
                </div>
            </div>
        </mat-drawer>
        <mat-drawer-content class="drawer-content" [style.marginLeft.px]="isCollapsed ? 85 : 280">
            <router-outlet></router-outlet>
        </mat-drawer-content>
    </mat-drawer-container>
</div>